import { createContext } from '@lyearn/core/utils/context';

import { CoverType } from '../../../ImageList/types';
import { DesignCard } from '../../enums';

interface ContextValue {
  overlayContent: {
    type: DesignCard;
  };
  setOverlayContent: ({ type }: { type: DesignCard }) => void;
  previewCover: CoverType;
  setPreviewCover: (cover: CoverType) => void;
  contentName: string;
  contentAuthor?: string;
  currentCoverUrl?: string;
  onSubmitCover: (url: string, name: string) => Promise<boolean>;
}

export const [DesignContextProvider, useDesignContext] = createContext<ContextValue>('Design');
